import React, { FC } from 'react'
import { useStoryContext } from '../StoryContext'
import { useZonesList } from '../../../modulesCommon/serviceHooks'
import { Badge } from '@wmgtech/legato'

type TZoneBadgeProps = {

}

export const ZoneBadge: FC<TZoneBadgeProps> = (props) => {
  const story = useStoryContext()
  const { getZoneById } = useZonesList()
  const isGlobal = story.global_status === 'PUBLISHED'
  const zoneId = (isGlobal && story.shared_from?.label_id) || story.campaign?.label_id || ''
  const zone = getZoneById(zoneId)
  return zone ? (
    <Badge
      size={'xs'}
      rounded
      text={zone.alias}
      colorType={'white'}
      containerStyle={'outline'}
    />
  ) : null
}
